import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-market",
  "use": "icon-market-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-market\"><defs><style type=\"text/css\"></style></defs><path d=\"M124.032 99.968l125.312 0 0 829.376-125.312 0 0-829.376Z\" p-id=\"32117\" /><path d=\"M346.688 99.968 346.688 592 901.312 345.984Z\" p-id=\"32118\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol